import { message } from 'antd';
import API from 'utils/api';
import { onError } from 'utils/handlers';

export const baseURI = 'nominas/firmar-nombramiento-masivo/';

export const postFirmarNombramientoMasivo = async (data) => {
  try {
    const response = await API.post(baseURI, data);
    return response.data;
  } catch (err) {
    // El backend devuelve un motivo por cada nombramiento del lote (mismo
    // mensaje repetido si fallaron por la misma razón, p. ej. "depende de").
    // Se deduplica aquí en vez de dejar que el modal genérico de onError()
    // muestre el mismo texto una vez por nombramiento.
    const errores = err?.response?.data?.errores;
    if (Array.isArray(errores) && errores.length) {
      const motivos = [...new Set(errores.map((e) => e.error))].join(' | ');
      message.warning(`${errores.length} nombramiento(s) no se pudieron firmar: ${motivos}`, 8);
    } else {
      onError(err);
    }
    return null;
  }
};

export const baseURIImprimir = 'nominas/imprimir-nombramiento-masivo/';

export const postImprimirNombramientoMasivo = async (data) => {
  try {
    const response = await API.post(baseURIImprimir, data);
    return response.data;
  } catch (err) {
    const errores = err?.response?.data?.errores;
    if (Array.isArray(errores) && errores.length) {
      const motivos = [...new Set(errores.map((e) => e.error))].join(' | ');
      message.warning(`${errores.length} nombramiento(s) no se pudieron marcar como impresos: ${motivos}`, 8);
    } else {
      onError(err);
    }
    return null;
  }
};

export const postSubirPdfNombramientoFea = async (nombramientoId, pdfFile, publico = true) => {
  try {
    const formData = new FormData();
    formData.append('nombramiento_id', nombramientoId);
    formData.append('pdf', pdfFile);
    formData.append('publico', publico ? 'true' : 'false');
    const response = await API.post('nominas/subir-pdf-nombramiento-fea/', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

export const getConsultarFirmaNombramientoFea = async (nombramientoId) => {
  try {
    const response = await API.get(`nominas/consultar-firma-nombramiento-fea/${nombramientoId}/`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

export const getBitacoraFirmaElectronica = async (params = {}) => {
  try {
    const response = await API.get('nominas/bitacora-firma-electronica/', { params });
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};
